export default function buildPatchFilterElement({
    apiEndpoint,
    apiTools
}) {
    return async function patchFilterElement(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/element` 
        })
       
        const res = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json',
            'Authorization': 'salaTokken'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}